import { useEmployees } from "@/queries/employees/use-employees.query";
import { ApiEmployeeFilter } from "@/types/employees/employee.types";
import { isEqual } from "lodash";
import { useState } from "react";

export const useEmployeesModel = () => {
  const [filters, setFilters] = useState<ApiEmployeeFilter | null>(null);

  const { data: employeesData, isLoading: isEmployeesLoading } = useEmployees(
    filters ?? {},
    filters !== null
  );

  const updateFilters = async (filter: ApiEmployeeFilter) => {
    if (isEqual(filters, filter)) return;
    setFilters(filter);
  };

  return {
    employeesData,
    isEmployeesLoading,
    updateFilters,
  };
};
